<template>
  <Teleport to="body">
    <Transition name="dropdown">
      <div
        v-if="isOpen"
        ref="contentEl"
        class="app-dropdown noprint"
        :style="floatingStyles">
        <slot :close="close" />
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, watch } from 'vue'

defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  floatingStyles: {
    type: Object,
    required: true
  },
  close: {
    type: Function,
    required: true
  }
})

const emit = defineEmits(['update:contentRef'])

const contentEl = ref(null)

watch(contentEl, (el) => {
  emit('update:contentRef', el)
})
</script>
